import React, { FC } from 'react';
import { sanitizeInline } from '@web/utils';

export const ErrorDetail: FC<{ errorDetail: string; style?: React.CSSProperties }> = ({ errorDetail, style }) => {
    const cleanErrorDetail = sanitizeInline(errorDetail?.trim());
    return <p dangerouslySetInnerHTML={{ __html: cleanErrorDetail }} style={style} />;
};
